module.exports = __webpack_public_path__ + "img/authorlevel2.84d2df50.png";